<template>
    <w-card-form
       v-bind="formProps"
       v-on="formEvents"
    >
        <template slot="top">
            <!-- @slot top -->
            <slot name="top"></slot>
        </template>
        <!-- @slot Default slot for form field components (rendered before the default components). -->
        <slot></slot>
        <v-flex xs12 v-if="showEmail">
            <w-text-field
                :disabled="!emailEnabled"
                :hint="emailHint"
                persistent-hint
                icon="email"
                label="Email Address"
                :rules="[validationRules.generic.required, validationRules.email.minLength, validationRules.email.valid]"
                :value="formData.email_address"
            ></w-text-field>
        </v-flex>
        <v-flex xs12>
            <w-password-field
                label="Current Password"
                :error-messages="fieldErrors('confirm_password')"
                :value="formData.current_password"
                :custom-rules="[validationRules.generic.required]"
                @enter="handleSubmit"
                @focus="clearFieldErrors('current_password')"
                @input="(val) => setFieldData('current_password', val)"
            ></w-password-field>
        </v-flex>
        <v-flex xs12>
            <w-password-field
                label="New Password"
                :additional-rules="additionalRules"
                :custom-rules="[validationRules.generic.required]"
                :error-messages="fieldErrors('password')"
                :value="formData.password"
                @enter="handleSubmit"
                @focus="clearFieldErrors('password')"
                @input="updatePassword"
            ></w-password-field>
        </v-flex>
        <v-flex xs12>
            <w-password-field
                label="Confirm New Password"
                :additional-rules="additionalRules"
                :custom-rules="[validationRules.generic.required]"
                :value="formData.password_confirm"
                validate-on-blur
                :error-messages="passwordConfirmErrorMessage"
                :disabled="$_.isEmpty(formData.password)"
                @enter="handleSubmit"
                @focus="clearFieldErrors('password_confirm')"
                @input="updatePasswordConfirm"
            ></w-password-field>
        </v-flex>
        <!-- @slot Additional form field components (rendered below the default fields). -->
        <slot name="additional"></slot>
    </w-card-form>
</template>

<script>
    import WAuthPasswordFormMixin from '../../mixins/forms/w-auth-password-form-mixin'
    import WTextField from '../WTextField'

    const formData = () => ({
        email_address: '',
        current_password: '',
        password: '',
        password_confirm: ''
    })

    /**
     * Form component to allow a user to change their password.
     */
    export default {
        name: 'WAuthChangePasswordForm',
        mixins: [WAuthPasswordFormMixin],
        components: {
            WTextField
        },
        data: () => ({
            formData: formData()
        }),
        props: {
            /**
             * Whether to center form text
             */
            align: {
                type: String,
                default: 'center'
            },
            /**
             * Description at the top of the form.
             */
            description: {
                type: String,
                default: 'Please change your password.'
            },
            /**
             * Show the email field.
             */
            showEmail: {
                type: Boolean,
                default: true
            },
            /**
             * Enable the email field.
             */
            emailEnabled: {
                type: Boolean,
                default: false
            },
            /**
             * Hint to show in the email form field.
             */
            emailHint: {
                type: String,
                default: 'Please contact your account manager to have this changed.'
            },
            /**
             * Title of the form.
             */
            title: {
                type: String,
                default: 'Change Password'
            }
        },
        methods: {
            initFormData: formData
        }
    }
</script>
